module.exports = "<button class=\"btn gmap-button\" ng-click=\"controlClick();toggle = !toggle;\"><span ng-show=toggle><l10n>Hide Rates</l10n></span><span ng-hide=toggle><l10n>Show Rates</l10n></span></button>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/trains-base/templates/mapButton.tmpl.html
// module id = 3707
// module chunks = 0